var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subject",
    class: {
      'subject--is-expanded': _vm.detailIsExpanded
    }
  }, [_c('div', {
    staticClass: "subject__index d-flex align-items-center"
  }, [_c('span', {
    staticClass: "subject__sequence"
  }, [_vm._v("第 " + _vm._s(_vm.index + 1) + " 頁")])]), _c('div', {
    staticClass: "subject__title"
  }, [_c('b-form-input', {
    ref: "titleInputRef",
    class: {
      'is-invalid': _vm.validate && _vm.titleValidState === false
    },
    attrs: {
      "disabled": _vm.isReadOnly,
      "state": _vm.validate ? _vm.titleValidState : null,
      "placeholder": _vm.validate && _vm.titleValidState === false ? _vm.validationMessage : ''
    },
    on: {
      "input": function input(value) {
        return _vm.$emit('update:title', value);
      }
    },
    model: {
      value: _vm.vModelForTitle,
      callback: function callback($$v) {
        _vm.vModelForTitle = $$v;
      },
      expression: "vModelForTitle"
    }
  })], 1), _c('div', {
    staticClass: "subject__sorting d-flex align-items-center"
  }, [_c('i', {
    staticClass: "mdi mdi-24px mdi-drag-horizontal cursor-grab subject-layout-drag-handler"
  }), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveUpIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('top');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-collapse-up"
  }), _vm._v(" 移至最頂 ")]), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveUpIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('up');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-up"
  }), _vm._v(" 上移 ")]), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveDownIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('down');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-down"
  }), _vm._v(" 下移 ")]), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveDownIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('bottom');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-collapse-down"
  }), _vm._v(" 移至最底 ")])], 1), _c('div', {
    staticClass: "subject__deletion d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": "danger",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.confirmForDeletion
    }
  }, [_c('span', {
    staticClass: "mdi mdi-delete"
  }), _vm._v(" 移除 ")])], 1), _c('div', {
    staticClass: "subject__options",
    class: {
      'd-none': !_vm.detailIsExpanded
    }
  }, [_vm.visibleConditionIsVisible ? _c('VisibleConditionEditor', {
    attrs: {
      "fieldOptionsForVisibleConditions": _vm.fieldOptionsForVisibleConditions
    },
    on: {
      "input": _vm.handleVisibleConditionChanges,
      "cleaned": function cleaned($event) {
        _vm.visibleConditionIsVisible = false;
      }
    },
    model: {
      value: _vm.vModelForVisibleConditions,
      callback: function callback($$v) {
        _vm.vModelForVisibleConditions = $$v;
      },
      expression: "vModelForVisibleConditions"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "subject__toggle-wrapper"
  }, [_c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.visibleConditionIsVisible ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.toggleVisibleCondition
    }
  }, [_c('span', {
    staticClass: "mdi mdi-lightbulb-on-outline"
  }), _vm._v(" 觸發顯示 ")])], 1)], 1), _c('div', {
    staticClass: "subject__slot",
    class: {
      'd-none': !_vm.detailIsExpanded
    }
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "subject__expand"
  }, [_c('b-button', {
    staticClass: "d-flex align-items-center justify-content-center w-100 border-0 bg-white",
    on: {
      "click": _vm.toggleDetails
    }
  }, [_c('i', {
    staticClass: "mdi mdi-24px mdi-chevron-down"
  })])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }